import { createTheme, ThemeProvider, styled, responsiveFontSizes } from '@mui/material/styles'

let theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#528586',
      dark: '#1F3232',
    },
    secondary: {
      main: '#f50057',
    },
    error: {
      main: '#C55865',
    },
    info: {
      main: '#1F3232',
    },
    text: {
      primary: '#1F3232',
      secondary: '#528586',
    },
    background: {
      default: '#ffffff',
      light: '#E8F1F1',
      pink: '#FDFAFA',
    },
    customPink: {
      main: '#FDFAFA',
      light: '#FDFAFA'
    },
    divider: '#528586',
    primaryBtn: {
      main: '#487475',
      light: '#BBD5D5',
      dark: '#1F3232',
      contrastText: '#fff'
    },
    lightBtn: {
      main: '#FFFFFF',
      light: '#FFFFFF',
      dark: '#FFFFFF',
      contrastText: '#1F3232'
    }
  },
  
  breakpoints: {
    values: {
      xs: 0,
      sm: 428,
      md: 820,
      lg: 1200,
      xl: 1536,
    }
  },
  maxwidth: 736,
  maxavatar: 96,
  spacing: 8,
  typography: {
    fontSize: 16,
    fontFamily: 'Asap',
  },
});
theme = responsiveFontSizes(theme)

const CustomTheme = (props) => <ThemeProvider theme={theme} >{props.children}</ThemeProvider>

export default CustomTheme